import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{width:window.innerWidth >768 ? 'auto' : '100%'}}>
        <Container fluid ={true}>
          <Row>
            <Col sm={6}>{new Date().getFullYear()} ©  Govindani Infotech Pvt. Ltd.</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Crafted with <i className="mdi mdi-heart text-danger"></i> by
                Govindani Infotech Pvt. Ltd.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>

  );
}

export default Footer;